import { withAlpha } from "utils/colorUtils";

// ==============================|| OVERRIDES - GLOBAL SCROLLBAR ||============================== //

export default function Scrollbar(theme) {
  const primaryMain =
    theme.vars?.palette?.primary?.main || theme.palette.primary.main;
  const trackColor = withAlpha(
    primaryMain,
    theme.palette.mode === "dark" ? 0.12 : 0.08,
  );
  const thumbColor = withAlpha(
    primaryMain,
    theme.palette.mode === "dark" ? 0.88 : 0.76,
  );
  const thumbHoverColor = withAlpha(
    primaryMain,
    theme.palette.mode === "dark" ? 1 : 0.92,
  );

  const webkitScrollbar = {
    width: "1px !important",
    height: "1px !important",
  };

  return {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          // Firefox supports only auto | thin | none.
          scrollbarWidth: "thin",
          scrollbarColor: `${thumbColor} ${trackColor}`,
          msOverflowStyle: "auto",
        },
        "*::-webkit-scrollbar": webkitScrollbar,
        "*::-webkit-scrollbar-track": {
          backgroundColor: trackColor,
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: thumbColor,
          borderRadius: 999,
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: thumbHoverColor,
        },
        // App scroll regions: reserve gutter so the thumb does not cover content.
        "[data-app-scroll-region]": {
          scrollbarGutter: "stable",
        },
      },
    },
  };
}
